<template>
  <VFileList
    v-if="getFiles?.length && $route.params.id && isShowList"
    class="mb-20"
    :files="getFiles"
    :show-delete="!isBidder"
    grid
    @on-delete="handlerDelete" />

  <VFile
    v-if="isCreate"
    id="supportingDocumentation"
    v-model="formData.supportingDocumentation"
    class="max-w-initial mb-60"
    name="supportingDocumentation"
    multi-file
    grid
    :server-errors="serverErrors.value?.supportingDocumentation" />
</template>

<script setup>
import { defineExpose, defineProps, defineComponent, computed, inject } from 'vue'
import { useStore } from 'vuex'

import VFile from '@/components/ui/form/File/VFile'
import VFileList from '@/components/list/FileList/VFileList'

const props = defineProps({
  isBidder: {
    type: Boolean,
    required: false,
  },
  isCreate: {
    type: Boolean,
    required: false,
    default: true,
  },
  formData: {
    type: Object,
    required: false,
  },
  serverErrors: {
    type: Object,
    required: false,
  },
  isShowList: {
    type: Boolean,
    required: false,
    default: true,
  },
})

const store = useStore()

const getFiles = computed(() => {
  return store.getters['files/getFiles']
})

const handlerDelete = (file) => {
  store.commit('files/deleteFile', file)
}

const formData = props.formData ? props.formData : inject('formData')
const serverErrors = props.serverErrors ? props.serverErrors : inject('serverErrors')

defineExpose({
  getFiles,
  handlerDelete,
})

defineComponent({
  VFile,
  VFileList,
})
</script>
